const { createSelector } = require('reselect')

const selectHospitalList = state => state.hospitalDomain.hospitalList

const getHospitalList = () => createSelector(
  [selectHospitalList],
  cse => cse.data,
)

const getHospitalListError = () => createSelector(
  [selectHospitalList],
  cse => cse.error,
)

const getHospitalListLoading = () => createSelector(
  [selectHospitalList],
  cse => cse.loading,
)

const selectHospital = state => state.hospitalDomain.hospital

const getHospital = () => createSelector(
  [selectHospital],
  cse => cse.data,
)

const getHospitalError = () => createSelector(
  [selectHospital],
  cse => cse.error,
)

const getHospitalLoading = () => createSelector(
  [selectHospital],
  cse => cse.loading,
)

const selectCreate = state => state.hospitalDomain.create

const getCreateHospital = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreateHospitalError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreateHospitalLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)
const selectUpdate = state => state.hospitalDomain.update

const getUpdateHospital = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdateHospitalError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdateHospitalLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)

const selectUpdateStatus = state => state.hospitalDomain.updateStatus

const getUpdateHospitalStatus = () => createSelector(
  [selectUpdateStatus],
  cse => cse.data,
)

const getUpdateHospitalStatusError = () => createSelector(
  [selectUpdateStatus],
  cse => cse.error,
)

const getUpdateHospitalStatusLoading = () => createSelector(
  [selectUpdateStatus],
  cse => cse.loading,
)

const selectDelete = state => state.hospitalDomain.delete

const getDeleteHospitalRes = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeleteHospitalError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeleteHospitalLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

module.exports = {
  getHospitalList,
  getHospitalListLoading,
  getHospitalListError,
  getHospital,
  getHospitalLoading,
  getHospitalError,
  getCreateHospital,
  getCreateHospitalLoading,
  getCreateHospitalError,
  getUpdateHospital,
  getUpdateHospitalLoading,
  getUpdateHospitalError,
  getUpdateHospitalStatus,
  getUpdateHospitalStatusError,
  getUpdateHospitalStatusLoading,
  getDeleteHospitalRes,
  getDeleteHospitalError,
  getDeleteHospitalLoading,
}
